import React from 'react';
import { Button } from 'semantic-ui-react';
import NewUpdateChildren from './StepParentMatch/new-updateChildren';
import StepParentMatchChildrenTable from './StepParentMatch/stepParentMatch-Table';
import GuestPlainData from '../../../components/helpers/guests/GuestPlainData';

const StepParentMatchChildren = (props) => {
  const { parent, children, getInfo, set_step, setInputs } = props;
  const [Attendant, set_Attendant] = React.useState(parent);

  React.useEffect(() => {
    set_Attendant(parent);
  }, [parent?.id, parent?.identification, parent?.photo]);

  const GoBackButton = () => (
    <Button
      size="mini"
      secondary
      onClick={() => {
        set_step(1);
        setInputs({});
      }}
    >
      Volver al inicio
    </Button>
  );

  return (
    <div className="parentMatch">
      <div className="back">
        <GoBackButton />
      </div>
      <h2>Acudiente</h2>
      <div className="acudiente">
        <div className="info-acudiente">
          <GuestPlainData
            guest={Attendant}
            onGuestUpdated={({ identification }) => getInfo(identification)}
          />
        </div>
      </div>
      <div className="children">
        <h2>Niños a su cargo</h2>
        <NewUpdateChildren parent={parent} getInfo={getInfo} />
        <p style={{ fontSize: '18px', margin: '15px 0', fontStyle: 'italic' }}>
          Al ingresar a su hijo al sistema, así como usar los servicios de generaciones, <br />
          estás aceptando los terminos y condiciones de Iglesia Comunidad Cristiana de Fé Viento
          Fresco.
        </p>
        {!!children.length && (
          <StepParentMatchChildrenTable
            children={children}
            parent={parent}
            getInfo={getInfo}
            set_step={set_step}
            setParentInputs={setInputs}
          />
        )}
      </div>
      <div className="back bottom">
        <GoBackButton />
      </div>
    </div>
  );
};

export default StepParentMatchChildren;
